import { msalConfig } from '@/msAuthConfig'
import { EventType, PublicClientApplication } from '@azure/msal-browser'
import { LicenseInfo } from '@mui/x-license'
import ReactDOM from 'react-dom/client'

import App from './App'

// ========= SSO Provider setup =========
/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * It is recommended initializing this outside of the root component to ensure it is
 * not re-initialized on re-renders
 */
// eslint-disable-next-line import/prefer-default-export
const msalInstance = new PublicClientApplication(msalConfig)
declare global {
	interface Window {
		msalInstance: PublicClientApplication
	}
}

// Storing the msalInstance in window allows for it to be accessed from anywhere in the application.
// This was originally exported but using it that way creates a circular dependency.
window.msalInstance = msalInstance

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
	// Account selection logic is app dependent. Adjust as needed for different use cases.
	msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
}

// Optional - This will update account state if a user signs in from another tab or window
msalInstance.enableAccountStorageEvents()

msalInstance.addEventCallback((event: any) => {
	if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
		const { account } = event.payload
		msalInstance.setActiveAccount(account)
	}
})
// ========= SSO Provider setup =========

// Set the MUI license key (note: need to update in other places as well, do a search)
LicenseInfo.setLicenseKey(
	'f2040b6f71d422dd6a1f0eb17f2d06daTz0xMzExMDUsRT0xODE1NjA5NTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1pbml0aWFsLEtWPTI='
)
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
ReactDOM.createRoot(document.getElementById('root')!).render(
	// <StrictMode>
	<App pca={msalInstance} />
	// </StrictMode>
)
